import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Grid } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { BreadCrumbsComponent } from '../../../components/breadcrumbs/breadcrumbsComponent';
import { SubHeader } from '../../organizations/subheader';
import { styles } from './dictionary-upload.styles';
import Input from '../../../components/input/input';
import { useDispatch, useSelector } from 'react-redux';
import { buildDispatchable } from '../../../actions/_action-utilities';
import { uploadDictionary } from '../../../actions/dictionary-request.actions';
import history from '../../../history';
import { initUpload } from '../../../actions/dictionary-values';
import './dictionary-upload.scss';
import { LOAD_STATES } from '../../../reducers/common';
import { Button } from '../../../components/button/button';
const DictionaryNameField = {
    label: `Dictionary Name`,
    key: `dictionaryName`,
    helpText: 'The name of the dictionary',
    placeholder: '',
    required: true,
    type: 'text'
};
const DictionaryDescriptionField = {
    label: `Dictionary Description`,
    key: `description`,
    helpText: 'Description of the dictionary',
    placeholder: '',
    required: false,
    type: 'text'
};
const DictionaryPurposeField = {
    label: `Dictionary Purpose`,
    key: `purpose`,
    helpText: 'Purpose of the dictionary',
    placeholder: '',
    required: false,
    type: 'text'
};
const jiraTicketField = {
    label: `Jira Ticket`,
    key: `jiraTicket`,
    helpText: 'Jira Ticket associated with this change',
    placeholder: '',
    required: true,
    type: 'text'
};
export const defaultMetadataForm = {
    fieldGroups: [
        {
            label: 'Dictionary Metadata',
            fields: [
                DictionaryNameField,
                DictionaryDescriptionField,
                DictionaryPurposeField
            ]
        }
    ],
    buttons: [
        {
            className: 'qa-add-button qa-upload-button',
            buttonType: 'submit',
            buttonText: 'Submit'
        },
        {
            buttonType: 'link',
            buttonText: 'cancel',
            link: '/cmx/admin/users'
        }
    ]
};
export const metadataFormJiraField = {
    fieldGroups: [
        {
            label: 'Dictionary Metadata',
            fields: [
                DictionaryNameField,
                DictionaryDescriptionField,
                DictionaryPurposeField,
                jiraTicketField
            ]
        }
    ],
    buttons: [
        {
            className: 'qa-add-button qa-upload-button',
            buttonType: 'submit',
            buttonText: 'Submit'
        },
        {
            buttonType: 'link',
            buttonText: 'cancel',
            link: '/cmx/admin/users'
        }
    ]
};
export const DictionaryUpload = ()=>{
    const classes = styles();
    const dictionaryValuesState = useSelector((state)=>{
        return state.dictionaryValues;
    });
    const dictionaryRequestState = useSelector((state)=>{
        return state.dictionaryRequest;
    });
    const loadState = useSelector((state)=>{
        return state.dictionaryRequest.loadState;
    });
    const chosenTenantId = useSelector((state)=>{
        return {
            uuid: state.dictionary.selectedOrg.key
        };
    });
    const dispatch = useDispatch();
    const runDispatchable = buildDispatchable(dispatch);
    const [file, changeFile] = useState(undefined);
    const [dictionaryData, setDictionaryData] = useState({
        description: dictionaryRequestState.dictionaryMetadata.description,
        purpose: dictionaryRequestState.dictionaryMetadata.purpose,
        dictionaryName: dictionaryRequestState.dictionaryMetadata.dictionaryName
    });
    const inputRef = useRef(null);
    useEffect(()=>{
        dispatch(initUpload({
            ...dictionaryValuesState.selectedDictionary,
            tenantId: {
                uuid: chosenTenantId.uuid
            }
        }));
    }, [
        dispatch,
        chosenTenantId.uuid,
        dictionaryValuesState.selectedDictionary
    ]);
    useEffect(()=>{
        setDictionaryData({
            description: dictionaryRequestState.dictionaryMetadata.description,
            purpose: dictionaryRequestState.dictionaryMetadata.purpose,
            dictionaryName: dictionaryRequestState.dictionaryMetadata.dictionaryName
        });
    }, [
        dictionaryRequestState
    ]);
    const onFileInput = (fileEvent)=>{
        const { files } = fileEvent.target;
        if (files !== null && files.length && files[0]) {
            changeFile(files[0]);
        }
    };
    const onSubmit = ()=>{
        if (file !== undefined) {
            runDispatchable(()=>{
                return dispatch(uploadDictionary({
                    dictionaryCSV: file,
                    successRoute: window.location.pathname.split('/').slice(0, 6).join('/'),
                    isCreate: dictionaryRequestState.isUploadCreate,
                    ...dictionaryRequestState.dictionaryMetadata,
                    description: dictionaryData.description,
                    purpose: dictionaryData.purpose,
                    dictionaryName: dictionaryData.dictionaryName,
                    columnDefinitionMetadata: dictionaryRequestState.dictionaryMetadata.columnDefinitionMetadata,
                    isCorrection: dictionaryValuesState.isCorrection,
                    jiraTicket: dictionaryData.jiraTicket ?? null
                }));
            });
        }
    };
    const handleModalInputChange = (event)=>{
        const target = event.target;
        const { value, name } = target;
        setDictionaryData({
            ...dictionaryData,
            [name]: value
        });
    };
    const handleAction = ()=>{
        history.goBack();
    };
    const validateJiraTicket = (jiraTicket)=>{
        const jiraTicketRegex = /^[a-zA-Z]+-\d+$/;
        return dictionaryValuesState.isCorrection ? !jiraTicket && !jiraTicketRegex.test(jiraTicket) : false;
    };
    const enabler = ()=>{
        return dictionaryData?.dictionaryName === '' || file === undefined || loadState === LOAD_STATES.started || loadState === LOAD_STATES.initial || validateJiraTicket(dictionaryData?.jiraTicket);
    };
    const header = !dictionaryValuesState.isCorrection ? 'Upload Dictionary' : 'Make a Correction';
    const fields = dictionaryValuesState.isCorrection ? metadataFormJiraField.fieldGroups : defaultMetadataForm.fieldGroups;
    const fileUpload = ()=>{
        inputRef.current.click();
    };
    return /*#__PURE__*/ _jsxs(Box, {
        overflowY: "auto",
        children: [
            /*#__PURE__*/ _jsx(BreadCrumbsComponent, {}),
            /*#__PURE__*/ _jsx(SubHeader, {
                title: header,
                linkButtonName: 'Cancel',
                onLinkButtonClick: handleAction,
                actionName: 'Submit',
                onActionClick: onSubmit,
                isActionDisabled: enabler()
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                sx: classes.fieldsets,
                children: [
                    fields?.map((item)=>{
                        return /*#__PURE__*/ _jsxs("fieldset", {
                            style: classes.fieldset,
                            children: [
                                /*#__PURE__*/ _jsx("legend", {
                                    style: classes.legend,
                                    children: item.label
                                }),
                                /*#__PURE__*/ _jsx(Flex, {
                                    flexDirection: 'column',
                                    rowGap: 5,
                                    width: '33%',
                                    sx: classes.contentSpacing,
                                    children: item.fields.map((field)=>{
                                        return /*#__PURE__*/ _jsx(Input, {
                                            label: field.label,
                                            type: 'text',
                                            onChange: handleModalInputChange,
                                            placeholder: `Enter ${field.label}`,
                                            name: field.key,
                                            textInfo: field.helpText ?? '',
                                            isRequired: field.required,
                                            dataTestId: field.label,
                                            value: dictionaryData[field.key]
                                        });
                                    })
                                })
                            ]
                        });
                    }),
                    /*#__PURE__*/ _jsxs("fieldset", {
                        style: classes.fieldset,
                        children: [
                            /*#__PURE__*/ _jsx("legend", {
                                style: classes.legend,
                                children: "File"
                            }),
                            /*#__PURE__*/ _jsxs(Flex, {
                                sx: classes.contentSpacing,
                                alignItems: 'center',
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        label: 'Choose File',
                                        onClick: fileUpload
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        hidden: true,
                                        ref: inputRef,
                                        type: "file",
                                        onChange: onFileInput,
                                        multiple: false
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: classes.fileName,
                                        children: file?.name
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
